import { LOCALE } from "~/constants/locale"

export default defineNuxtPlugin(() => {
  const locale = useState("locale").value || LOCALE.UK

  useHead({
    htmlAttrs: {
      lang: locale
    }
  })
})
